<template>
  <div style="display: flex;flex-direction: row">
    <div class="custom-tree-container" style="width: 20%;overflow-x:scroll;white-space: nowrap; height: 85vh;">
      <el-input
          v-model="filterText"
          style="width: 200px;"
          placeholder="输入关键字进行过滤"/>
      <div style="width:120%">
        <el-tree
            ref="tree"
            :data="data"
            :props="defaultProps"
            :filter-node-method="filterNode"
            node-key="id"
            :expand-on-click-node="false">
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <span @click="tree(data)">{{data.label}}</span>
          </span>
        </el-tree>
      </div>
    </div>
    <el-main style="padding:0;margin-left: 30px;width:100vh">
      <vm-table
          ref="vmTable"
          height="64vh"
          :filter.sync="filter"
          module="basic"
          url="departments"
          @select="selectTest"
          @select-all="selectAll">
        <div slot="toolbar">
          <el-button type="primary" @click="$refs.editDepartment.open(0)">新建</el-button>
          <el-button type="danger" @click="deleteIds">批量删除</el-button>
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="查询">
              <el-input v-model.trim="filter.filter" clearable/>
            </vm-search>
            <vm-search label="外部编号">
              <el-input v-model.trim="filter.outerNO" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column type="selection" align="center" width="55"/>
        <el-table-column prop="departmentNO" align="center" label="编号"/>
        <el-table-column prop="outerNO" align="center" label="外部编号"/>
        <el-table-column prop="departmentName" align="center" label="名称"/>
        <el-table-column prop="directorName" align="center" label="部门主管"/>
        <el-table-column prop="parentName" align="center" label="上级部门"/>
        <el-table-column prop="fax" align="center" label="传真"/>
        <el-table-column prop="telephone" align="center" label="电话"/>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            width="120px">
          <template slot-scope="scope">
            <el-button type="info" @click="$refs.editDepartment.open(scope.row.departmentID)">编辑</el-button>
            <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </vm-table>
      <department-edit ref="editDepartment" @save-success="getList(1)"/>
    </el-main>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  // import VmTree from "@/components/VmTree";
  import DepartmentEdit from "@/views/information/Department/DepartmentEdit";
  export default {
    name: "DepartmentList",
    components: {DepartmentEdit,VmTable,VmSearch},
    data() {
      return {
        idList: "",
        filter: {
          filter: "",
          outerNO: "",
          parentID: "",
          departmentIDs:"",
        },
        data: [],
        filterText: "",
        defaultProps: {
          children: "children",
          label: "",
          other: "",
        },
      };
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
    mounted() {
      this.$refs.vmTable.getList(1);
      this.getData();
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      getData() {
        this.$http
          .get("basic","departments/tree").then((res) => {
            this.data = res;
          });
      },
      tree(data) {
        console.log(data);
        this.filter.parentID = data.id;
        this.getList(1);
      },
      filterNode(value, data, node) {
        //console.log(data);
        if (!value) {
          return true;
        }
        if (node.parent.parent !== null && node.parent.visible) {
          return true;
        }
        return data.label.indexOf(value) !== -1;
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.departmentID);
          }
          console.log(ids);
          this.$http
            .delete("basic","departments/idList",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","departments",row.departmentID).then(() => {
              this.getList(1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
